class SearchOverlay {

    constructor() {
        this.addListeners();
        this.removeSearchListeners();
        this.scrollingPrevented = false;
    }

    removeSearchListeners() {
        const cluster = document.getElementById('removeSearchCluster')
        const nine = document.getElementById('removeSearchNine')
        const eleven = document.getElementById('removeSearchEleven')

        if (cluster) {
            cluster.addEventListener('click', () => {
                let url = new URL(window.location.href);                
                url.searchParams.delete('cluster');            
                window.location.href = url.href;
            })
        }

        if (nine) {
            nine.addEventListener('click', () => {
                let url = new URL(window.location.href);                
                url.searchParams.delete('nine');            
                window.location.href = url.href;
            })
        }

        if (eleven) {
            eleven.addEventListener('click', () => {
                let url = new URL(window.location.href);                
                url.searchParams.delete('eleven');            
                window.location.href = url.href;
            })
        }
    }

    addListeners() {
        const search = document.querySelectorAll('.search-button');
        const overlay = document.getElementById('searchOverlay');
        const btn = document.getElementById('searchCloseButton');

        if (search && overlay && btn) {
            search.forEach(item => {
                item.addEventListener('click', () => {
                    this.openSearch();
                }) 
            })

            btn.addEventListener('click', () => {
                this.closeSearch();
            })
        }
    }

    openSearch() {
        const overlay = document.getElementById('searchOverlay');
        overlay.classList.add('search-overlay--active');
        const body = document.querySelector('body');
        body.classList.add('stop-scroll');
        window.addEventListener('keydown', this.escHandler);
    }

    closeSearch() {
        const overlay = document.getElementById('searchOverlay');
        overlay.classList.remove('search-overlay--active');
        const body = document.querySelector('body');
        body.classList.remove('stop-scroll');
        window.removeEventListener('keydown', this.escHandler);
    }

    escHandler = (event) => {
        //console.log(this)
        if (event.keyCode === 27) {
            this.closeSearch()
          }
    }
}

export default SearchOverlay